module.exports = __webpack_public_path__ + "img/cta-bg.2abe8c48.png";